import { render } from "./ConocenosPage.vue?vue&type=template&id=3f8af6a5&scoped=true"
import script from "./ConocenosPage.vue?vue&type=script&lang=js"
export * from "./ConocenosPage.vue?vue&type=script&lang=js"

import "./ConocenosPage.vue?vue&type=style&index=0&id=3f8af6a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8af6a5"]])

export default __exports__